import NoteIcon from '../components/icons/NoteIcon';

export const getElements = () => [
    {
        id: 'outcome',
        name: 'Outcome',
        style: 'outcome',
        tooltip: {
            title: 'Outcome',
            content: '',
        },
        flow: 'Outcome',
        icon: '',
        background: '',
        isGroupCell: false,
        display: false,
        hasConfiguration: true,
    },
    {
        id: 'start',
        name: 'Start',
        style: 'start',
        tooltip: {
            title: 'Start',
            content: '',
        },
        flow: 'Map Element Start',
        icon: '',
        background: '#4CD964',
        isGroupCell: false,
        display: false,
        hasConfiguration: true,
    },
    {
        id: 'step',
        name: 'Step',
        style: 'step',
        tooltip: {
            title: 'Step',
            content: 'Display rich text content to the user',
        },
        flow: 'Map Element Step',
        icon: 'map-marker',
        background: '#62b7ed',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'input',
        name: 'Page',
        style: 'input',
        tooltip: {
            title: 'Page',
            content: 'Display complex forms to the user',
        },
        flow: 'Map Element Page',
        icon: 'th',
        background: '#67a5e7',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'decision',
        name: 'Decision',
        style: 'decision',
        tooltip: {
            title: 'Decision',
            content: 'Change the path through the Flow based on criteria',
        },
        flow: 'Map Element Decision',
        icon: 'ok',
        background: '#7ccf60',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'operator',
        name: 'Operator',
        style: 'operator',
        tooltip: {
            title: 'Operator',
            content: 'Create & update values',
        },
        flow: 'Map Element Operator',
        icon: 'cog',
        background: '#5fcc64',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'message',
        name: 'Message',
        style: 'message',
        tooltip: {
            title: 'Message',
            content: 'Send requests to 3rd party systems',
        },
        flow: 'Map Element Message',
        icon: 'envelope',
        background: '#54c473',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'database_load',
        name: 'Load',
        style: 'database_load',
        tooltip: {
            title: 'Load',
            content: 'Load data from an external source',
        },
        flow: 'Map Element Database Load',
        icon: 'upload',
        background: '#f87d76',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'database_save',
        name: 'Save',
        style: 'database_save',
        tooltip: {
            title: 'Save',
            content: 'Save data to an external source',
        },
        flow: 'Map Element Database Save',
        icon: 'download',
        background: '#eb687f',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'database_delete',
        name: 'Delete',
        style: 'database_delete',
        tooltip: {
            title: 'Delete',
            content: 'Delete data from an external source',
        },
        flow: 'Map Element Database Delete',
        icon: 'remove-circle',
        background: '#d95879',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'swimlane',
        name: 'Swimlane',
        style: 'swimlane',
        tooltip: {
            title: 'Swimlane',
            content: 'Restrict access to part of a Flow to specific users or groups',
        },
        flow: 'Map Element Swimlane',
        icon: 'user',
        background: '#f49756',
        isGroupCell: true,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'group',
        name: 'Group',
        style: 'group',
        tooltip: {
            title: 'Group',
            content: 'Organize your Flow at build time using groups',
        },
        flow: null,
        icon: 'folder-open',
        background: '#855dc4',
        isGroupCell: true,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'subflow',
        name: 'Subflow',
        style: 'subflow',
        tooltip: {
            title: 'Subflow',
            content: 'Move into a child flow',
        },
        flow: null,
        icon: 'triangle-bottom',
        background: '#607D8B',
        isGroupCell: false,
        display: true,
        hasConfiguration: true,
    },
    {
        id: 'return',
        name: 'Return',
        style: 'return',
        tooltip: {
            title: 'Return',
            content: 'Return back to the parent flow',
        },
        flow: null,
        icon: 'triangle-top',
        background: '#9E9E9E',
        isGroupCell: false,
        display: true,
        hasConfiguration: false,
    },
    {
        id: 'note',
        name: 'Note',
        style: 'note',
        tooltip: {
            title: 'Note',
            content: 'Add annotations to your flow',
        },
        flow: null,
        icon: NoteIcon,
        background: '#DE6854',
        isGroupCell: false,
        display: true,
        hasConfiguration: false,
    },
];
